






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { GET_RESERVATION_TYPES, GET_MATCHER, GET_MATCHER_FOR_DISPLAY, GET_DATE_TIME_FORMAT } from '@/system/store/getter-types'
import { IReservationType, IMatcherItem } from '@/features/matchFields/store'
import { IActionType } from '@/system/store'
import { SET_MATCH_FIELD, CLEAR_MATCH_FIELD, VALID_MATCHER } from '@/system/store/action-types'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'

@Component
export default class MatchFieldsSelect extends Vue {
  private translations = matchFieldsLocalisationKeys
  private selectedValue: any = ''
  private options: IReservationType[] = []
  private fullList: IReservationType[] = []

  @Prop()
  readonly item!: IMatcherItem
  @Getter(GET_RESERVATION_TYPES)
  types!: IReservationType[]
  @Getter(GET_MATCHER)
  matcher!: string
  @Getter(GET_MATCHER_FOR_DISPLAY)
  matcherForDisplay!: any[]
  @Getter(GET_DATE_TIME_FORMAT)
  dateTimeFormat!: string
  @Action(SET_MATCH_FIELD)
  setMatchField!: IActionType
  @Action(CLEAR_MATCH_FIELD)
  clearMatchField!: IActionType
  @Action(VALID_MATCHER)
  validMatcher!: IActionType

  @Watch('selectedValue')
  changedSelection (newVal: IReservationType, oldVal: IReservationType) {
    if (oldVal) {
      this.removeOptionFromMatcher(oldVal)
    }
  }

  protected created (): void {
    this.fullList = [...this.types]
  }

  public handleValidation () {
    this.validMatcher({
      matcher: this.matcher,
      matcherForDisplay: this.matcherForDisplay,
      dateTimeFormat: this.dateTimeFormat
    })
  }

  private handleSelect (selectedElement: IReservationType): void {
    const { value } = selectedElement

    this.toogleDisbaleSelectedAndDependantOptions(selectedElement)
    this.setMatchField({ item: this.item, value })
    this.handleValidation()
  }

  private handleClear (): void {
    this.removeOptionFromMatcher(this.selectedValue)
    this.selectedValue = ''
  }

  private removeOptionFromMatcher (option: IReservationType): void {
    const { value } = option
    this.toogleDisbaleSelectedAndDependantOptions(option, false)
    this.clearMatchField({ value })
    this.handleValidation()
  }

  private toogleDisbaleSelectedAndDependantOptions (el: IReservationType, disable: boolean = true): void {
    const { value } = el
    const exclusions = ['room_name']
    if (!exclusions.includes(value)) el.disable = disable

    if (value === 'date') {
      this.fullList.forEach((opt: IReservationType) => {
        if ((opt.value.startsWith('date') || opt.value.startsWith('timestamp'))) opt.disable = disable
      })
    }

    if (/^time_|^date_/.test(value)) {
      const [, suffix] = value.split('_')
      if (suffix) {
        this.fullList.forEach((opt: IReservationType) => {
          if (opt.value.startsWith('timestamp')) opt.disable = disable
          if (opt.value === 'date' && value.startsWith('date_')) opt.disable = disable
        })
      }
    }

    if (value.startsWith('timestamp')) {
      this.fullList.forEach((opt: IReservationType) => {
        if (/^time_|^date_/.test(opt.value)) opt.disable = disable
        if (opt.value === 'date') opt.disable = disable
      })
    }
  }

  private filterFn (filter: string, update: Function, abort: Function) {
    update(() => {
      if (this.selectedValue.label && filter && filter !== this.selectedValue.label) {
        this.removeOptionFromMatcher(this.selectedValue)
        this.selectedValue = ''
      }

      const needle: string = filter.toLowerCase()
      this.options = this.fullList
        .filter(({ label }: IReservationType) => label.toLowerCase().includes(needle))
    })
  }
}
